<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0&icon_names=manage_accounts" />
<div class="flex flex-col fill">
  <mic-header color="white">
    <div class="flex flex-row items-center justify-between">
      <div class="flex flex-row flex-none items-center gap-4">
        <mic-sidebar-toggler [alwaysDisplay]="true" id="main-sidebar-toggler" type="left"></mic-sidebar-toggler>
        <a href="/" class="logo">
          <img src="assets/logo.svg" alt="{{ 'altLogo' | translate }}">
        </a>
      </div>
      <mic-navbar-spacer></mic-navbar-spacer>
      <div class="username">
        {{ this.claims.last_name }} {{ this.claims.first_name }}
      </div>
      <mic-navbar-icon (click)="logout()" icon="logout"></mic-navbar-icon>
      <mat-select class="lang-selector" [value]="defaultLang" (valueChange)="setLanguage($event)">
        @for (lang of supportedLangs; track lang) {
        <mat-option value="{{lang}}">{{ lang | uppercase }}</mat-option>
        }
      </mat-select>
    </div>
  </mic-header>

  <mic-sidebar-container leftToggler="main-sidebar-toggler">
    <mic-sidebar position="start">
      <mic-sidebar-item
        link="/home"
        [icon]="{key: 'database', type: 'svg'}"
        [label]="'home.home' | translate"
        (click)="resetAllBreadCrumb()"
        (keydown)="onSidebarItemKeyDown($event)">
      </mic-sidebar-item>
      <mic-sidebar-item
        link="/measure"
        [icon]="{key: 'database',
        type: 'svg'}"
        [label]="'menu.measure' | translate">
      </mic-sidebar-item>
      <mic-sidebar-item
        link="/analyse"
        [icon]="{key: 'finance', type: 'svg'}"
        [label]="'menu.analyse' | translate">
      </mic-sidebar-item>
      <mic-sidebar-item
        *ngIf="isCurrentUserAdmin"
        link="/administration"
        [label]="'menu.administration' | translate"
        icon="person">
      </mic-sidebar-item>
      <mic-sidebar-item
        link="/contact-us"
        [label]="'menu.contactemail' | translate"
        icon="contact_support">
      </mic-sidebar-item>

    </mic-sidebar>
    <mic-main-content main>
      <div class="flex flex-col fill justify-between" content>
        <div class="sidebar-container-content flex justify-center">
          <div class="flex flex-col w-4on5 lg-w-full py-4">
            <router-outlet></router-outlet>
          </div>
        </div>
        <footer>
          <ul>
            <a routerLink="/cgu">{{ "footer.cgu" | translate }}</a>
            <a routerLink="/legal-notice">{{ "footer.legalNotice" | translate }}</a>
            <a routerLink="/privacy-policy">{{ "footer.privacyPolicy" | translate }}</a>
          </ul>

          Copyright {{ year }} MICHELIN © All rights reserved
        </footer>
      </div>
    </mic-main-content>

  </mic-sidebar-container>
  <mic-alert-center [hideDelay]="4" [hideAll]="true"></mic-alert-center>
</div>
